import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ExternalLinkState {
  url: string | null;
  title: string | null;
  // Whether the "open in new tab" control should be shown for this link.
  showRedirectIcon: boolean;
}

const initialState: ExternalLinkState = {
  url: null,
  title: null,
  showRedirectIcon: false,
};

const externalLinkSlice = createSlice({
  name: 'externalLink',
  initialState,
  reducers: {
    setExternalLink: (
      state,
      action: PayloadAction<{ url: string; title: string; showRedirectIcon?: boolean }>
    ) => {
      state.url = action.payload.url;
      state.title = action.payload.title;
      state.showRedirectIcon = action.payload.showRedirectIcon === true;
    },
    clearExternalLink: (state) => {
      state.url = null;
      state.title = null;
      state.showRedirectIcon = false;
    },
  },
});

export const { setExternalLink, clearExternalLink } = externalLinkSlice.actions;
export const ExternalLinkReducer = externalLinkSlice.reducer;

